// Module
var code = `<div data-bind="clickOutside: hide" class="suggest position-relative text-left">
    <div data-bind="visible: loader() > 0" class="suggest-loader">
        <div class="spinner-grow text-primary" role="status"></div>
    </div>
    <div class="input-group">
        <input data-bind="textInput: inputText, event: {keydown: handleKey, click: show}, css: {'form-control-sm': size == 'small'}, hasFocus: autoFocus(), attr: {placeholder: placeholder}" name="searchterm" type="text" class="suggest-search-input" autocomplete="off" autocapitalize="none">
        <button data-bind="click: reset" type="reset" title="Zoekopdracht verwijderen" class="clear-icon"></button>
<!--        <div data-bind="visible: isVisible" class="input-group-append">-->
<!--            &lt;!&ndash; todo: fix button css + icon &ndash;&gt;-->
<!--            <button data-bind="click: hide" class="search-reset btn btn-outline-danger" type="button">(Verberg)</button>-->
<!--        </div>-->
<!--        <div class="input-group-append">-->
<!--            &lt;!&ndash; todo: fix button css + icon &ndash;&gt;-->
<!--            <button class="search-submit btn btn-outline-primary" type="submit">(Zoeken)</button>-->
<!--        </div>-->
    </div>
    <div data-bind="visible: isVisible" class="suggest-items">
        <!-- ko foreach: {data: sortedSuggestions, as: 'suggestion'} -->
        <div data-bind="visible: suggestion.suggestions.length, text: suggestion.title" class="suggest-group-title"></div>
        <div data-bind="template: { name: 'search-autocomplete-' + suggestion.group, foreach: suggestion.suggestions, as: 'suggestion' }" class="suggest-group"></div>
        <!-- /ko -->
        <div data-bind="css: {'xsuggest-active': currentFocus() == 0}, visible: inputText().length > 0" class="suggest-item-button">
            <a data-bind="attr: {href: '/search?searchterm=' + inputText()}" class="primary-button medium">
                Toon alle zoekresultaten<!--Toon alle zoekresultaten voor <span class="font-italic font-weight-bold" data-bind="text: inputText()"></span>-->
            </a>
        </div>
    </div>
</div>

${"<" + "script"} type="text/html" id="search-autocomplete-product">
    <div data-bind="css: {'suggest-active': suggestion.index == \$parentContext.\$parentContext.\$data.currentFocus()}" class="suggest-item suggest-item-product">
        <div data-bind="visible: suggestion.count > 1" class="suggest-item-count">
            <span data-bind="text: suggestion.count">0</span> varianten
        </div>
        <a data-bind="attr: {href: suggestion.url}">
                <div data-bind="visible: suggestion.imageUrl != null, style: {'background-image': 'url(' + suggestion.imageUrl+ ')'}" class="suggest-item-product-image"></div>
                <div class="suggest-item-product-info">
                    <p class="suggest-item-product-brand" data-bind="text: suggestion.brand"></p>
                    <h5 class="suggest-item-product-title" data-bind="html: suggestion.html"></h5>
                    <div>
                        <p data-bind="visible: !_.isEmpty(suggestion.text), text: suggestion.text + '...'" style="white-space: pre-wrap"></p>
<!--                        <div data-bind="visible: !_.isEmpty(suggestion.properties), foreach: _.filter(suggestion.properties, (property) => !_.isNull(property.value))">-->
<!--                            <span data-bind="text: key + ': ' + value" class="badge badge-pill badge-light">Light</span>-->
<!--                        </div>-->
                        <div class="suggest-item-product-properties">
                            <span data-bind="text: \`Artikelnr. \${suggestion.sku}\`"></span>
                            <!-- ko if: !_.isEmpty(_.filter(suggestion.properties, (prop) => prop.highlight)) -->
                                <!-- ko foreach: _.filter(suggestion.properties, (propertyValue) => propertyValue.highlight && !_.isNull(propertyValue.value)) -->
                                    <span data-bind="text: \`| \${\$data.name}: \${\$data.value}\`"></span>
                                <!-- /ko -->
                            <!-- /ko -->
                        </div>
                        <div class="suggest-item-product-price-container">
                            <span data-bind="text: suggestion.price" class="suggest-item-product-price"></span> <span data-bind="text: \`/ \${suggestion.uomDescription}\`" class="suggest-item-product-price-moq"></span>
                        </div>
                    </div>
                </div>
        </a>
    </div>
${"<" + "/script"}>

${"<" + "script"} type="text/html" id="search-autocomplete-brand">
    <div data-bind="css: {'suggest-active': suggestion.index == \$parentContext.\$parentContext.\$data.currentFocus()}" class="suggest-item suggest-item-brand">
        <a data-bind="html: suggestion.html, attr: {href: suggestion.url}"></a>
    </div>
${"<" + "/script"}>
${"<" + "script"} type="text/html" id="search-autocomplete-property_Soort">
    <div data-bind="css: {'suggest-active': suggestion.index == \$parentContext.\$parentContext.\$data.currentFocus()}" class="suggest-item suggest-item-property_Soort">
        <a data-bind="html: suggestion.html, attr: {href: suggestion.url}"></a>
    </div>
${"<" + "/script"}>
${"<" + "script"} type="text/html" id="search-autocomplete-category">
    <div data-bind="css: {'suggest-active': suggestion.index == \$parentContext.\$parentContext.\$data.currentFocus()}" class="suggest-item suggest-item-category">
        <ol class="breadcrumb">
        <!-- ko if: !_.isUndefined(suggestion.rootCategory) && !_.isNull(suggestion.rootCategory) -->
        <li class="breadcrumb-item ">
            <a data-bind="text: suggestion.rootCategory.name, attr: {href: '/categories/' + suggestion.rootCategory.slug}">
            </a>
        </li>
        <!-- /ko -->
        <!-- ko if: !_.isUndefined(suggestion.subCategory) && !_.isNull(suggestion.subCategory) -->
        <li class="breadcrumb-item ">
            <a data-bind="text: suggestion.subCategory.name, attr: {href: '/categories/' + suggestion.rootCategory.slug + '/' + suggestion.subCategory.slug}">
            </a>
        </li>
        <!-- /ko -->
        <li class="breadcrumb-item ">
            <a data-bind="html: suggestion.html, attr: {href: suggestion.url}"></a>
        </li>
        </ol>
    </div>
${"<" + "/script"}>
${"<" + "script"} type="text/html" id="search-autocomplete-spellcheck">
    <div data-bind="css: {'suggest-active': suggestion.index == \$parentContext.\$parentContext.\$data.currentFocus()}" class="suggest-item suggest-item-spellcheck">
        <a data-bind="html: suggestion.html, attr: {href: suggestion.url}"></a>
    </div>
${"<" + "/script"}>
`;
// Exports
module.exports = code;